import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';

import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../enums';

const Component = () => import('./ManageBrandSubEntity.vue');

export default [
  {
    path: buildChildURL(
      LocalMenuGroupRoutePathNames.ID,
      LocalMenuGroupRoutePathNames.BRAND_DETAILS,
      LocalMenuGroupRoutePathNames.BRAND_ID,
      LocalMenuGroupRoutePathNames.ENTITY,
      LocalMenuGroupRoutePathNames.ENTITY_ID,
      LocalMenuGroupRoutePathNames.MODE,
    ),
    name: LocalMenuGroupRouteNames.ENTITY_MANAGEMENT,
    component: Component,
  },
  // Route for an item opened from a Category
  {
    path: buildChildURL(
      LocalMenuGroupRoutePathNames.ID,
      LocalMenuGroupRoutePathNames.BRAND_DETAILS,
      LocalMenuGroupRoutePathNames.BRAND_ID,
      LocalMenuGroupRoutePathNames.MENUS,
      LocalMenuGroupRoutePathNames.MENU_ID,
      LocalMenuGroupRoutePathNames.CATEGORY,
      LocalMenuGroupRoutePathNames.CATEGORY_ID,
      LocalMenuGroupRoutePathNames.ENTITY,
      LocalMenuGroupRoutePathNames.ENTITY_ID,
      LocalMenuGroupRoutePathNames.MODE,
    ),
    name: LocalMenuGroupRouteNames.CATEGORY_CHILD_MANAGEMENT,
    component: Component,
  },
  // Route for a Modifier opened within a Mod Group

  {
    path: buildChildURL(
      LocalMenuGroupRoutePathNames.ID,
      LocalMenuGroupRoutePathNames.BRAND_DETAILS,
      LocalMenuGroupRoutePathNames.BRAND_ID,
      LocalMenuGroupRoutePathNames.MOD_GROUP,
      LocalMenuGroupRoutePathNames.MOD_GROUP_ID,
      LocalMenuGroupRoutePathNames.ENTITY,
      LocalMenuGroupRoutePathNames.ENTITY_ID,
      LocalMenuGroupRoutePathNames.MODE,
    ),
    name: LocalMenuGroupRouteNames.MOD_GROUP_CHILD_MANAGEMENT,
    component: Component,
  },
] as RouteRecordRaw[];
